import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 bg-white" data-id="element-70">
      <div className="container mx-auto px-4" data-id="element-71">
        <div className="max-w-5xl mx-auto" data-id="element-72">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center border-b-4 border-[#B1050B] pb-4 inline-block w-full" data-id="element-73">
            Contact Us
          </h2>
          <div className="grid md:grid-cols-2 gap-12" data-id="element-74">
            <div data-id="element-75">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-black pl-4" data-id="element-76">
                Get In Touch
              </h3>
              <div className="space-y-6" data-id="element-77">
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-78">
                  <PhoneIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-79" />
                  <div data-id="element-80">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-81">Phone</h4>
                    <a href="tel:2484788382" className="text-[#B1050B] hover:text-[#8A0408] text-lg transition-colors" data-id="element-82">
                      (248) 478-8382
                    </a>
                  </div>
                </div>
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-83">
                  <MapPinIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-84" />
                  <div data-id="element-85">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-86">Address</h4>
                    <p className="text-gray-700" data-id="element-87">
                      24445 Grand River Ave
                      <br data-id="element-88" />
                      Farmington Hills, MI 48335
                    </p>
                  </div>
                </div>
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-89">
                  <ClockIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-90" />
                  <div data-id="element-91">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-92">Hours</h4>
                    <div className="text-gray-700" data-id="element-93">
                      <p data-id="element-94">Monday - Friday: 7:00 AM - 4:00 PM</p>
                      <p data-id="element-95">Saturday - Sunday: Closed</p>
                    </div>
                  </div>
                </div>
                <div className="flex items-start border-l-2 border-[#B1050B] pl-4" data-id="element-96">
                  <MailIcon size={24} className="text-[#B1050B] mr-4 mt-1" data-id="element-97" />
                  <div data-id="element-98">
                    <h4 className="font-bold text-gray-900 mb-1" data-id="element-99">Email</h4>
                    <a href="mailto:info@garrettauto.com" className="text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-100">
                      info@garrettauto.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-101">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 border-l-4 border-black pl-4" data-id="element-102">
                Service Area
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-103">
                We proudly serve the following communities and surrounding
                areas:
              </p>
              <ul className="grid grid-cols-2 gap-3 text-gray-700 mb-8" data-id="element-104">
                <li data-id="element-105">• Farmington</li>
                <li data-id="element-106">• Farmington Hills</li>
                <li data-id="element-107">• Novi</li>
                <li data-id="element-108">• Commerce</li>
                <li data-id="element-109">• Walled Lake</li>
                <li data-id="element-110">• Livonia</li>
              </ul>
              <div className="bg-black text-white border-l-4 border-[#B1050B] p-6 rounded" data-id="element-111">
                <h4 className="font-bold mb-3 text-[#B1050B]" data-id="element-112">Our Mission</h4>
                <p className="text-gray-300" data-id="element-113">
                  Garrett Auto & Truck Service is here to serve you by
                  performing the highest quality automotive & truck repairs at
                  fair prices, using only proven materials of the highest
                  quality. Our service is backed by our personal pledge of
                  customer satisfaction.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-12 bg-[#B1050B] text-white p-8 rounded-lg text-center border-4 border-black shadow-lg" data-id="element-114">
            <h3 className="text-2xl font-bold mb-4" data-id="element-115">
              Ready to Schedule Service?
            </h3>
            <p className="text-red-100 mb-6 text-lg" data-id="element-116">
              Call us today or stop by our shop. We're here to help with all
              your automotive and truck repair needs.
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-black text-white hover:bg-gray-900 px-8 py-3 rounded font-bold transition-colors border-2 border-[#D4AF37]" data-id="element-117">
              <PhoneIcon size={20} className="mr-2" data-id="element-118" />
              Call (248) 478-8382
            </a>
          </div>
        </div>
      </div>
    </section>;
}